import { render, staticRenderFns } from "./PlatformInfo.vue?vue&type=template&id=32ea10a2&"
import script from "./PlatformInfo.vue?vue&type=script&lang=js&"
export * from "./PlatformInfo.vue?vue&type=script&lang=js&"
import style0 from "./PlatformInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports